import firebase from 'firebase/app';
require("firebase/firestore");
require("firebase/auth");
require("firebase/storage");

// CLIENT-SIDE: Firebase web app creds
var firebaseConfig = {
    apiKey: "AIzaSyBOGqC8F9TUqprWn4DZEfOt23L8kncOOl8",
    projectId: "axo-sports",
    storageBucket: "axo-sports.appspot.com",
    messagingSenderId: "219995195587",
    appId: "1:219995195587:web:8ce19e82287323658a3a76",
    measurementId: "G-79RPFL4LCN",
    authDomain: "axo-sports.firebaseapp.com"
    //authDomain: 'auth.axos.cc',       // if we want to show something diff
};
firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();
export const storage = firebase.storage();
export const firebaseAuth = firebase.auth;

//export const VIMEO_POST ="?autoplay=1&loop=1&autopause=1&muted=1&controls=0"
//export const YOUTUBE_POST ="?rel=0&autoplay=1&modestbranding=1&loop=1" // mute=1
export const VIMEO_POST ="?&muted=1&controls=0"
export const YOUTUBE_POST ="?rel=0&modestbranding=1&loop=1" // mute=1

export const GOOGLE_BUCKET_SERVER = process.env.REACT_APP_GOOGLE_BUCKET_HOST
const BACKEND_HOST = process.env.REACT_APP_BACKEND_API_HOST
export const BUCKET_API_SERVER = BACKEND_HOST
export const NODE_API_SERVER = BACKEND_HOST
export const REST_API_SERVER = BACKEND_HOST

// SERVER-SIDE
//var Vimeo = require('vimeo').Vimeo;
//var client = new Vimeo("{client_id}", "{client_secret}", "{access_token}");
export const  VIMEO_BEARER_TOKEN = '41b5639ba14578be2db0f6ddb2bd9d55';
export const IPAPI_TOKEN = "vA4ZJcvUdqacNpTIuOjaNQfsVDh0K3DdyxCe86u9vlNonMtoBg"

